import React, { useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/layout/Navbar";

/** Embeds a VENKA application form under the site header. The iframe fills the rest of the screen and
 *  scrolls on its own, so the form's step list stays visible. ?embed=1 tells the form it is inside the site. */
export const FormFrame = ({ src, title, testid }) => {
  const { i18n } = useTranslation();
  const iframeRef = useRef(null);
  const lang = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);

  const url = useMemo(() => {
    const params = new URLSearchParams(window.location.search); // carries ?demo, ?name, ?email, ?phone
    params.set("lang", lang);
    params.set("embed", "1");
    return `${src}?${params.toString()}`;
  }, [src]);

  useEffect(() => {
    iframeRef.current?.contentWindow?.postMessage({ type: "venka-lang", lang }, "*");
  }, [lang]);

  return (
    <div className="h-[100dvh] flex flex-col bg-[#070c1a]" data-testid={testid}>
      <Navbar />
      <iframe ref={iframeRef} title={title} src={url} data-testid={`${testid}-iframe`} className="flex-1 w-full border-0 bg-[#070c1a]" />
    </div>
  );
};

export default FormFrame;
